import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import TypingTimer from "./TypingTimer";
import { diffWords } from "diff";

const TypingModule = () => {
  const { testcode, exam, category } = useParams();
  const [message, setMessage] = useState("");
  const [paragraph, setParagraph] = useState("");
  const [minute, setMinute] = useState(0);
  const [rmTm, setrmTm] = useState();
  const [typing, setTyping] = useState(false);
  const [cookies] = useCookies(["token", "userData"]);
  const navigate = useNavigate();

  const hoursMinSecs = { hours: 0, minutes: minute, seconds: 0 };
  const emailId = cookies?.userData?.email_id || "";

  const handleMessageChange = (event) => {
    if (!typing) setTyping(true);
    setMessage(event.target.value);
  };

  const rmTimeFun = (rTm) => setrmTm(rTm);

  const fetchParagraph = async () => {
    const res = await fetch(
      "https://auth.ssccglpinnacle.com/api/typingParagraph",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${cookies.token}`,
        },
        body: JSON.stringify({ paper_code: testcode, exam }),
      }
    );
    const data = await res.json();
    setParagraph(data.paragraph);
    setMinute(data.time);
  };

  useEffect(() => {
    const checkAccess = async () => {
      const res = await fetch(
        "https://auth.ssccglpinnacle.com/api/checkAccessTyping",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${cookies.token}`,
          },
        }
      );
      const result = await res.json();
      if (result.access === "access") fetchParagraph();
      else navigate("/");
    };
    if (cookies.token) checkAccess();
    else navigate("/");
  }, [testcode, exam, cookies.token, navigate]);

  const messageSubmit = async () => {
    const originalParagraph = paragraph.trim();
    const userInput = message.trim();
    const diff = diffWords(originalParagraph, userInput);
    const comparisonResult = diff
      .map((part) => {
        const text = part.value;
        if (part.added)
          return `<span class='text-green-600 font-normal bg-green-200'>${text}</span>`;
        else if (part.removed)
          return `<span class='text-red-600 bg-red-200 font-normal'>${text}</span>`;
        else return `<span class='text-black'>${text}</span>`;
      })
      .join("");

    const finalParagraph = comparisonResult;
    let correctChars = 0;
    let wrongChars = 0;
    const totalDepressions = originalParagraph.length;

    diff.forEach((part) => {
      if (!part.added && !part.removed) correctChars += part.value.length;
      else if (part.added) wrongChars += part.value.length;
    });

    if (rmTm !== undefined) {
      const timeParts = rmTm.split(":");
      const totalSecondsUsed =
        +timeParts[0] * 3600 + +timeParts[1] * 60 + +timeParts[2];
      const totalTestSeconds = +minute * 60;
      const timeTaken = totalTestSeconds - totalSecondsUsed;

      const netSpeed = Math.round((correctChars * 60) / (timeTaken * 5));
      const grossSpeed = Math.round((message.length * 60) / (timeTaken * 5));

      const accuracy = ((correctChars / totalDepressions) * 100).toFixed(2);
      const wrongPercentage = (100 - accuracy).toFixed(2);

      const typing_performance_result = {
        email_id: emailId,
        paper_code: testcode,
        student_paragraph: message,
        paragraph: finalParagraph,
        accuracy,
        wrong: wrongPercentage,
        grossspeed: grossSpeed,
        totaldepres: totalDepressions,
        accuratedep: correctChars,
        wrongdep: wrongChars,
        speed: netSpeed,
        time: rmTm,
      };

      const response = await fetch(
        "https://auth.ssccglpinnacle.com/api/typingPerformance",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${cookies.token}`,
          },
          body: JSON.stringify(typing_performance_result),
        }
      );

      if (response.ok) {
        const result = await response.json();
        navigate(
          `/typingperformance/${accuracy}/${wrongPercentage}/${correctChars}/${netSpeed}/${testcode}/${exam}/${category}`
        );
      }
    }
  };

  if (rmTm === "00:00:00") messageSubmit();

  return (
    // <div className="min-h-screen bg-white text-sm md:text-base">
    //   <div className="bg-blue-600 py-2 px-4 text-white text-center font-mono">
    //     Typing Test 2025
    //   </div>
    //   <div className="bg-black text-white flex justify-between px-12 py-4 text-sm">
    //     <span>SSC {exam} T2 English</span>
    //     <span className="right-2">Instructions</span>
    //   </div>

    //   <div className="flex flex-col lg:flex-row gap-4 px-4 py-2 items-center mx-4">
    //     <button className="bg-blue-600 text-white px-4 py-1 rounded text-xs">
    //       Group 1
    //     </button>
    //     <button className="bg-gray-200 text-black px-4 py-1 rounded text-xs">
    //       Group 2
    //     </button>
    //     <button className="bg-gray-200 text-black px-4 py-1 rounded text-xs">
    //       Group 3
    //     </button>
    //   </div>

    //   <div className="flex justify-between items-center px-4 py-2 w-6xl">
    //     <hr className="flex-grow border-1 mx-4" />{" "}
    //     <span className="text-sm mb-6 right-85 mr-3 object-right position: absolute">
    //       Time Left:
    //     </span>
    //     <div className="flex flex-col items-center">
    //       <div className="w-30 h-30 border border-black flex items-center justify-center text-lg font-bold">
    //         {typing && (
    //           <TypingTimer hoursMinSecs={hoursMinSecs} rmTimeFun={rmTimeFun} />
    //         )}
    //       </div>
    //     </div>
    //   </div>

    //   <div className="bg-blue-600 text-white flex justify-between px-4 py-3 text-sm w-5xl">
    //     <span>Keyboard Layout: Inscript</span>
    //     <span>Language: English</span>
    //   </div>

    //   <div className="grid grid-cols-1 md:grid-cols-12 gap-6 px-6 py-6">
    //     <div className="md:col-span-7 space-y-4">
    //       <div className=" border p-4 h-48 overflow-y-auto text-black whitespace-pre-line">
    //         {paragraph}
    //       </div>
    //       <textarea
    //         className="w-full h-48 p-4 border text-black resize-none"
    //         value={message}
    //         onChange={handleMessageChange}
    //         spellCheck="false"
    //         maxLength={paragraph.length}
    //         onPaste={(e) => e.preventDefault()}
    //       />
    //     </div>

    //     <div className="md:col-span-5 space-y-4">
    //       <div className="text-black text-sm font-medium">English</div>
    //       <div className="flex gap-24 border-t pt-4 pb-4 ">
    //         <span className="text-gray-900 text-sm">Select Language:</span>
    //         <span className="text-green-600 text-sm">English(US)</span>
    //         <span className="text-blue-600 text-sm underline cursor-pointer border-r">
    //           Move
    //         </span>
    //       </div>
    //       <div className="flex mx-2 mt-18">
    //         <button
    //           onClick={messageSubmit}
    //           className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 mt-52 object-right right-0 position:absolute"
    //         >
    //           Submit
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="min-h-screen bg-white text-sm md:text-base">
      {/* 🔵 Top Bar */}
      <div className="bg-blue-600 py-2 px-4 text-white text-center font-mono text-sm sm:text-base">
        Typing Test 2026
      </div>

      {/* 📝 Title + Instructions */}
      <div className="bg-black text-white flex flex-col sm:flex-row justify-between items-center px-4 sm:px-8 py-2 text-xs sm:text-sm">
        <span className="mb-1 sm:mb-0">SSC {exam} T2 English</span>
        <span>Instructions</span>
      </div>

      {/* 👥 Group Buttons */}
      <div className="flex flex-wrap justify-center gap-3 px-4 py-3">
        {["Group 1", "Group 2", "Group 3"].map((group, idx) => (
          <button
            key={idx}
            className={`px-4 py-1 rounded text-xs sm:text-sm ${
              idx === 0
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }`}
          >
            {group}
          </button>
        ))}
      </div>

      {/* ⏲️ Timer Bar */}
      <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-2">
        <hr className="w-full sm:w-auto flex-grow border-1 my-2 sm:my-0 sm:mx-4" />
        <div className="flex items-center justify-between w-full sm:w-auto gap-2">
          <span className="text-sm">Time Left:</span>
          <div className="w-28 h-12 sm:w-28 sm:h-12 md:w-[120px]  md:h-[120px]  lg:w-[120px] lg:h-[120px] border border-black flex items-center justify-center text-lg font-bold text-center rounded bg-white">
            {typing && (
              <TypingTimer hoursMinSecs={hoursMinSecs} rmTimeFun={rmTimeFun} />
            )}
          </div>
          {/* 
            {typing && (
              <TypingTimer hoursMinSecs={hoursMinSecs} rmTimeFun={rmTimeFun} />
            )}
          </div> */}
        </div>
        <hr className="w-full sm:w-auto flex-grow border-1 my-2 sm:my-0 sm:mx-4 md:hidden lg:hidden" />
      </div>

      {/* 🧑‍💻 Layout and Language Info */}
      <div className="bg-blue-600 text-white flex flex-col sm:flex-row justify-between items-center px-4 py-2 text-sm">
        <span className="mb-1 sm:mb-0">Keyboard Layout: Inscript</span>
        <span>Language: English</span>
      </div>

      {/* 🔤 Typing + Sidebar */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 px-4 py-6">
        {/* 📜 Paragraph + Textarea */}
        <div className="md:col-span-7 space-y-4">
          <div className="border p-4 h-48 overflow-y-auto text-black whitespace-pre-line text-xs sm:text-sm md:text-base">
            {paragraph}
          </div>
          <textarea
            className="w-full h-48 p-4 border text-black resize-none text-xs sm:text-sm"
            value={message}
            onChange={handleMessageChange}
            spellCheck="false"
            maxLength={paragraph.length}
            onPaste={(e) => e.preventDefault()}
            placeholder="Start typing here..."
          />
        </div>

        {/* 🧾 Sidebar */}
        <div className="md:col-span-5 space-y-4">
          <div className="text-black font-medium text-sm sm:text-base">
            English
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:items-center justify-between border-t pt-4 pb-4">
            <span className="text-gray-900 text-sm">Select Language:</span>
            <span className="text-green-600 text-sm">English (US)</span>
            <button className="text-blue-600 text-sm underline cursor-pointer">
              Move
            </button>
          </div>

          {/* 📤 Submit Button */}
          <div className="flex justify-end">
            <button
              onClick={messageSubmit}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 text-sm sm:text-base"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingModule;
